import {
  faqState
} from "./faq.state";
import {
  faqActions
} from "./faq.actions";
import {
  faqGetters
} from "./faq.getters";
import {
  faqMutations
} from "./faq.mutations";

export default {
  state: faqState,
  actions: faqActions,
  getters: faqGetters,
  mutations: faqMutations
};